import React from 'react';

const CategoryRatingDiagram = ({
  // Sample data labels
  rowTitles = ['GMG Level 1', 'GMG Level 2', 'GMG Level 3', 'GMG Level 4', 'GMG Level 5'],
  columnTitles = ['Data', 'Mining', 'Concentrator', 'Market', 'Human'],

  // Sample data matrix
  cellData = [
    [
      { label: '✓', value: '100' },
      { label: '✓', value: '90' },
      { label: '✓', value: '80' },
      { label: '✓', value: '70' },
      { label: '✓', value: '60' }
    ],
    [
      { label: '✓', value: '85' },
      { label: '✓', value: '75' },
      { label: '✓', value: '65' },
      { label: '✓', value: '55' },
      { label: '✓', value: '45' }
    ],
    [
      { label: '✓', value: '70' },
      { label: '✓', value: '60' },
      { label: '✓', value: '50' },
      { label: '✓', value: '40' },
      { label: '✓', value: '30' }
    ],
    [
      { label: '✓', value: '55' },
      { label: '✓', value: '45' },
      { label: '✓', value: '35' },
      { label: '✓', value: '25' },
      { label: '✓', value: '15' }
    ],
    [
      { label: '✓', value: '40' },
      { label: '✓', value: '30' },
      { label: '✓', value: '20' },
      { label: '✓', value: '10' },
      { label: '✓', value: '0' }
    ]
  ],

  // Heat map colours
  colorLow = [157, 205, 10],
  colorHigh = [5, 83, 159],

  // Table stroke
  tableStrokeWidth = 10,
  tableStrokeColor = '#F8F8F8',

  // Typography
  fontFamily = 'Roboto, Franklin Gothic Medium, Tahoma, sans-serif',
  fontWeightBold = '500',
  fontWeightLight = '300',
  fontSizeLarge = '20px',
  fontSizeSmall = '11.5px',
  fontColorLight = '#FFFFFF',
  fontColorDark = '#000000',

  // Image proportions
  viewBox = '0 0 570 365'
}) => {
  // Picks a colour from the gradient between colorLow and colorHeigh
  // based on the weight (0.0 - 1.0)
  const colorHeat = (weight) => {
    if (weight === 0) return '#FFFFFF';

    const w1 = 1 - weight;
    const w2 = weight;

    const rgb = [
      Math.round(parseInt(colorLow[0]) * w1 + parseInt(colorHigh[0]) * w2),
      Math.round(parseInt(colorLow[1]) * w1 + parseInt(colorHigh[1]) * w2),
      Math.round(parseInt(colorLow[2]) * w1 + parseInt(colorHigh[2]) * w2)
    ].join(',');

    return `rgba(${rgb}, 1)`;
  };

  // Renders all cells of the table
  // Fills them with the weighted color and places a text label in the middle
  const renderCells = (data) => {
    const cells = [];
    data.map((row, rowIndex) =>
      cells.push(
        row.map((cell, colIndex) => (
          <g key={`${rowIndex}${colIndex}`}>
            <rect
              fill={colorHeat(Number(cell.value / 100))}
              x={110 + colIndex * 91}
              y={110 + rowIndex * 45}
              width="91"
              height="45"
            />

            <text
              transform={`matrix(1 0 0 1 ${156 + colIndex * 91} ${140 + rowIndex * 45})`}
              fill={fontColorLight}
              fontWeight={fontWeightLight}
              fontSize={fontSizeLarge}
              textAnchor="middle">
              {cell.label}
            </text>
          </g>
        ))
      )
    );
    return cells;
  };

  // Renders vertical lines for table
  const renderVerticalLines = () => {
    return [0, 1, 2, 3, 4, 5].map((line, index) => (
      <line
        key={index}
        vectorEffect="non-scaling-stroke"
        stroke={tableStrokeColor}
        strokeWidth={tableStrokeWidth}
        strokeLinecap="square"
        x1={110 + line * 91}
        y1="110"
        x2={110 + line * 91}
        y2="335"
      />
    ));
  };

  // Renders horizontal lines for table
  const renderHorizontalLines = () => {
    return [0, 1, 2, 3, 4, 5].map((line, index) => (
      <line
        key={index}
        vectorEffect="non-scaling-stroke"
        stroke={tableStrokeColor}
        strokeWidth={tableStrokeWidth}
        strokeLinecap="square"
        x1="110"
        y1={110 + line * 45}
        x2="565"
        y2={110 + line * 45}
      />
    ));
  };

  // Renders row labels on the left side
  const renderRowLabels = () => {
    return rowTitles.map((label, index) => (
      <g key={index}>
        <text
          transform={`matrix(1 0 0 1 52 ${135 + index * 45})`}
          textAnchor="middle"
          fill={fontColorDark}
          fontWeight={fontWeightBold}
          fontSize={fontSizeSmall}>
          {label}
        </text>
      </g>
    ));
  };

  // Render column labels on the top side
  const renderColumnTitles = () => {
    return columnTitles.map((label, index) => (
      <g key={index}>
        <text
          transform={`matrix(0.75 -0.75 0.75 0.75 ${150 + index * 91} 95)`}
          fill={fontColorDark}
          fontWeight={fontWeightBold}
          fontSize={fontSizeSmall}>
          {label}
        </text>
      </g>
    ));
  };

  return (
    <svg
      version="1.0"
      id="gmg_level_diagram"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={viewBox}
      fontFamily={fontFamily}>
      <g>{renderRowLabels()}</g>
      <g>{renderColumnTitles()}</g>
      <g>
        {renderCells(cellData)}
        {renderHorizontalLines()}
        {renderVerticalLines()}
      </g>
    </svg>
  );
};

export default CategoryRatingDiagram;
